window.addEventListener('load', (event) => {
    // Default settings
    const defaults = {
        fade: false,
        dots: false,
        slidesToShow: 1,
        touchThreshold: 100000000,
        swipeToSlide: true,
        mobileFirst: true,
    }

    // Testimonial slider
    $(".testimonials-slider-items").each(function () {
        const thisElement = $(this);
        const parentSlider = $(this).closest('.testimonials-slider-items');

        thisElement.slick({
            ...defaults,
            arrowsPlacement: 'afterSlides',
            centerMode: true,
            centerPadding: '0',
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 1200,
                settings: 'unslick'
            }, ]
        });
    });

    // Article slider
    $(".article-slider-items").each(function () {
        const thisElement = $(this);
        const parentSlider = $(this).closest('.article-slider');

        thisElement.slick({
            ...defaults,
            infinite: false,
            prevArrow: parentSlider.find('.slick-prev'),
            nextArrow: parentSlider.find('.slick-next'),
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            }, ]
        });
    })

    // Image slider
    $(".image-slider-items").each(function () {
        const thisElement = $(this);
        const parentSlider = $(this).closest('.image-slider');

        thisElement.slick({
            ...defaults,
            infinite: false,
            arrowsPlacement: 'afterSlides',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            }, ]
        });
    })
});